import { gql } from "@apollo/client";

export const BUILDING_FCFS_FIELDS_FRAGMENT = gql`
  fragment BuildingFcfsFieldsV2 on BuildingInterface {
    id
    slug
    url
    accessibilityDetails
    hasAccessibleUnits
    moveInRequirements
    amenities
    contactPhone
    contactEmail
    images {
      id
      accessibilityFeatures
    }
    availability {
      status
      bedrooms
      units {
        id
        deleted
        unitType
        unitCount
        fcfsUnitCount
        bathroomCount
        mobilityAccessible
        visionAccessible
        hearingAccessible
        rentType
        ami
        minIncome
        rentalCost
        isAffordable
        maxIncomes {
          id
          householdSize
          maxIncome
        }
      }
    }
    housingVacancy {
      id
      details
      notifyPropertyContact
      documents {
        id
        name
        category
        fileUrl
        filename
        extension
        __typename
      }
      unitGroups {
        id
        deleted
        unitType
        unitCount
        fcfsUnitCount
        fcfsUnitCount
        bathroomCount
        mobilityAccessible
        visionAccessible
        hearingAccessible
        rentType
        ami
        minIncome
        rentalCost
        isAffordable
        maxIncomes {
          id
          householdSize
          maxIncome
        }
      }
      __typename
    }
    __typename
  }
`;

export default BUILDING_FCFS_FIELDS_FRAGMENT;
